export const USERS_DEFAULT_STATE = {
  items: [],
};

function usersReducer(state = USERS_DEFAULT_STATE, action) {
  switch (action.type) {
    case "LOGIN_USER":
      return { ...state, savingLogin: true, loadingLogin: true };

    case "LOGIN_USER_SUCCESS":
      return {
        ...state,
        items: state.items.concat(action.credentials),
        token: action.credentials,
        savingLogin: false,
        loadingLogin: false,
        loginSuccess: true,
        loginError: null,
        loggedOut: false
      };

    case "LOGIN_FAILURE":
      return {
        ...state,
        loadingLogin: false,
        savingLogin: false,
        loginSuccess: false,
        loginError: action.error
      };

    // Logout User
    case "LOGOUT_USER":
      return { ...state, saving: true };

    case "LOGOUT_USER_SUCCESS":
      return { ...state, saving: false, loggedOut: true };

    case "LOGOUT_FAILURE":
      return { ...state, error: action.error };

    default:
      return state;
  }
}

export default usersReducer